import { capitalizeFirstLetter } from "./ApiFunctions";

export const GetValueLable = (arr, keyNames, emptyLabel) => {
  // Initialize the mapped array with the static value-label pair at the beginning
  const mappedArray = [
    { label: "Select", value: "" },
    ...arr.map((item) => ({
      value: item[keyNames[0]], // Get value from the first key provided
      label: capitalizeFirstLetter(keyNames.map((key) => item[key]).join(", ")), // Join values if multiple keys provided
    })),
  ];

  // If emptyLabel is provided, update the label of the first element
  if (emptyLabel) {
    mappedArray[0].label = emptyLabel;
  }

  return mappedArray;
};

// export const GetValueLableWithId = (arr, keyNames) => {
//   return arr.map((item) => {
//     const value = item[keyNames[0]]; // Get value from the first key provided
//     const label = item[keyNames[1]]; // Get label from the second key provided
//     return { value, label };
//   });
// };

// export const GetValueLableWithId = (arr, keyNames, emptyLabel) => {
//   const mappedArray = arr.map((item) => ({
//     value: item[keyNames[0]], // Get value from the first key provided
//     label: item[keyNames[1]], // Get label from the second key provided
//   }));

//   if (emptyLabel) {
//     mappedArray.unshift({
//       value: "",
//       label: emptyLabel ? emptyLabel : "Select",
//     }); // Add empty value with label at the beginning
//   }

//   return mappedArray;
// };
export const GetValueLableWithId = (arr, keyNames, emptyLabel) => {
  // Initialize the mapped array with the static value-label pair at the beginning
  const mappedArray = [
    { label: "Select", value: "" },
    ...arr.map((item) => ({
      value: item[keyNames[0]], // Get value from the first key provided
      label: capitalizeFirstLetter(item[keyNames[1]]), // Get label from the second key provided
    })),
  ];

  // If emptyLabel is provided, update the label of the first element
  if (emptyLabel) {
    mappedArray[0].label = emptyLabel;
  }

  return mappedArray;
};
export const GetValuedynamciLable = (arr, keyNames, emptyLabel, lables) => {
  // Initialize the mapped array with the static value-label pair at the beginning
  const mappedArray = [
    { label: lables, value: "" },
    ...arr.map((item) => ({
      value: item[keyNames[0]], // Get value from the first key provided
      label: capitalizeFirstLetter(item[keyNames[1]]), // Get label from the second key provided
    })),
  ];

  // If emptyLabel is provided, update the label of the first element
  if (emptyLabel) {
    mappedArray[0].label = emptyLabel;
  }

  return mappedArray;
};

// export const GetValueLableForNested = (arr, keyNames, emptyLabel) => {
//   const mappedArray = arr.map((item) => {
//     const value = item[keyNames[0]]; // Get value from the first key provided
//     let label = item;

//     for (let i = 1; i < keyNames.length; i++) {
//       const key = keyNames[i];
//       if (label && label.hasOwnProperty(key)) {
//         label = label[key];
//       } else {
//         label = ""; // Set label to empty string if any nested property doesn't exist
//         break;
//       }
//     }

//     return {
//       value,
//       label: label ? label.toString() : "", // Convert label to string if it exists
//     };
//   });

//   if (emptyLabel) {
//     mappedArray.unshift({
//       value: "",
//       label: emptyLabel,
//     });
//   }

//   return mappedArray;
// };

export const GetValueLableForNested = (arr, keyNames, emptyLabel) => {
  // Map the array to extract values and labels based on keyNames
  const mappedArray = arr.map((item) => {
    const value = item[keyNames[0]]; // Get value from the first key provided
    let label = item;

    // Traverse nested properties for the label
    for (let i = 1; i < keyNames.length; i++) {
      const key = keyNames[i];
      if (label && label.hasOwnProperty(key)) {
        label = label[key];
      } else {
        label = ""; // Set label to empty string if any nested property doesn't exist
        break;
      }
    }

    return {
      value,
      label: label ? capitalizeFirstLetter(label.toString()) : "", // Convert label to string if it exists
    };
  });

  // Add static entry at the beginning
  const staticEntry = {
    value: "",
    label: emptyLabel || "Select", // Use emptyLabel if provided, else "Select"
  };
  mappedArray.unshift(staticEntry);

  return mappedArray;
};
